import '../components/test.css'
import Assesment from '../components/mentor/assesment'
import Mentor from '../components/mentor/mentor'


function AddMentor() {
 

  return (
    <div className='newAdmin'> 
      <Mentor/>  
    </div>
  )
}

export default AddMentor
